import { Drawer, Typography, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function SummaryDrawer({ open, onClose, summary }) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          zIndex: 2001,
          color: "#fff",
          width: 350,
          boxShadow: 4,
          p: 3,
          borderLeft: "1px solid rgba(251, 250, 250, 0.48)",
          zIndex: 4001,
        },
      }}
    >
      <Box sx={{ position: "relative", minHeight: "60px", marginTop: 5 }}>
        <Typography
          variant="h6"
          sx={{
            color: "#fff",
            fontWeight: 700,

            marginTop: 5,
          }}
        >
          Summary
        </Typography>
      </Box>
      <Typography
        sx={{
          whiteSpace: "pre-wrap",
          fontSize: 16,
          color: "#fff !important",
          marginTop: 3,
        }}
      >
        {summary}
      </Typography>
    </Drawer>
  );
}

export default SummaryDrawer;
